// Breakpoint constants for responsive design
// These values match the Tailwind config screens (mobile-first, min-width)

export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,      // 주요 모바일/데스크톱 분기점
  XL: 1280,
  XXL: 1536,
}
